import React from "react";
import BlogMainpage from "../../components/Blog/BlogMainPage";
import Footer from "../../common/Footer/Footer";
import Header from '../../common/Header/Header';
import SEO from "../../components/SEO/SEO";

const BlogPage = () => {
  return (
    <div>
      <SEO
        title="Blog — Mental Health & Therapy Articles"
        description="Read expert articles on psychology, therapy, personal development and mental health. Stay informed and take care of your wellbeing."
        canonical="https://mindtherapycounselling.com/blog"
        ogType="website"
      />
      <Header />
      <BlogMainpage />
      <Footer />
    </div>
  );
};

export default BlogPage;
